export default "__VITE_ASSET__D2HiK64p__"